/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_AnnualInputs */

const en_common_annual = /** @type {(inputs: Common_AnnualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annual`)
};

const es_common_annual = /** @type {(inputs: Common_AnnualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anual`)
};

/**
* | output |
* | --- |
* | "Annual" |
*
* @param {Common_AnnualInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_annual = /** @type {((inputs?: Common_AnnualInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_AnnualInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_annual(inputs)
	return en_common_annual(inputs)
});